import {StyleSheet} from 'react-native';

import {cloudLight, denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  item: {
    alignItems: 'flex-start',
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  itemImage: {
    width: 60,
    height: 60,
    marginTop: 6,
  },
  itemContent: {
    width: '100%',
    gap: 2,
  },
  itemHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
  },
  itemTitle: {
    flex: 1,
  },
  itemMetaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
  },
  itemVolumeValue: {
    textAlign: 'right',
  },
  itemVolumeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 2,
  },
  trackingLinkText: {
    color: denim,
    textDecorationLine: 'underline',
  },
});
